module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "preexp-layout"
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-column": "",
      "md-gutter": "",
      "md-vertical-align": "center",
      "md-align": "center"
    }
  }, [_c('h1', {
    staticClass: "exp_desc"
  }, [_vm._v("Experiment is about to start. You'll have 5 seconds on each molecule")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-accent btn-start",
    on: {
      "click": _vm.gotoExperiment
    }
  }, [_vm._v("Start Experiment")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00c0a003"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PreExperiment.vue
// module id = 332
// module chunks = 1